import { lazy } from 'react';
const BulkCollectionInquiry = lazy(() => import('./BulkCollectionInquiry'));

const BulkCollectionInquiryRoutes = [
  {
    path: '/bulkcollectioninq',
    component: BulkCollectionInquiry
  }
];

export default BulkCollectionInquiryRoutes;
